import React from 'react';

import { type ControlProps } from '@atlaskit/select';

import { StyledControl } from './styled';

export const Control = ({ children, innerProps, innerRef }: ControlProps<any, true>) => (
	<StyledControl ref={innerRef ?? undefined} {...innerProps}>
		{children}
	</StyledControl>
);
